// http.js
import axios from 'axios';
//获取url参数
var url = location.href; //获取url中"?"符后的字串
console.log(url, 'url123')
if (url.indexOf("?") != -1) { //判断是否有参数
    let urlStr = url.split('?')[1]
    let obj = {};
    let paramsArr = urlStr.split('&')
    for (let i = 0, len = paramsArr.length; i < len; i++) {
        let arr = paramsArr[i].split('=')
        obj[arr[0]] = arr[1];
    }
    localStorage.setItem('alias',obj.alias.slice(0,8));
   
}
console.log(localStorage.getItem('alias')  ,'看看数据呀')
 const instance = axios.create({
    baseURL: 'https://applets.huotoupiao.com/',
    timeout: 3000,
    headers: {  
            'Access-Token': localStorage.getItem('largeScreenToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'alias': localStorage.getItem('alias'), 
        },
    transformRequest: [function (data, headers) {
      headers['Access-Token'] = localStorage.getItem('largeScreenToken')
      return JSON.stringify(data)
    }]

})  




// 现在你可以使用这个实例发送请求，它会自动带上你设置的请求头
export default instance;


